<div *ngIf="showstatus">
  <div class="modal-header" style="padding: 0px;">
    <div class="modal-title" id="exampleModalLabel">
      <mat-form-field style="margin-right: auto;" fxFlex="40%">
        <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Search">
      </mat-form-field>
    </div>
    <button
      type="button" mat-button
      (click)="close()" style="background-color: transparent;
      background-repeat: no-repeat;
      border: none;
      color: red;
      cursor: pointer;
      overflow: hidden;
      outline: none;"
    >
      <i class="fa fa-times"></i>
    </button>
  </div>
  <div class="d-flex justify-content-center" style="margin-top: 1%;">
    <div class="col-md-10">
      <div class="col-md-12">
        <div style="overflow-x: auto; justify-content: center;">
          <table mat-table matTableExporter [dataSource]="dataSource" matSort #exporter="matTableExporter"
            class="example-container mat-elevation-z8" style="width: auto; text-align: center;">
            <!-- TransformerID (Mapped to energyMeterId) -->
            <ng-container matColumnDef="TransformerID">
              <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: bold;background-color: wheat;cursor: pointer;">
                MeterID&nbsp;&nbsp;
              </th>
              <td mat-cell *matCellDef="let element" style="cursor: pointer;" (click)="open_individual(element.energyMeterId)">
                {{element.energyMeterId}}
              </td>
            </ng-container>
            <!-- SiteName (Mapped to alertStatus) -->
            <ng-container matColumnDef="SiteName">
              <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: bold;background-color: wheat;">
                Alert Status&nbsp;&nbsp;
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.alertStatus}}
              </td>
            </ng-container>
            <!-- Communication -->
            <ng-container matColumnDef="Communication">
              <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: bold;background-color: wheat;">
                Communication&nbsp;&nbsp;
              </th>
              <td mat-cell *matCellDef="let element">
                <div [ngClass]="{'dot': element.status === 'Online', 'blackdot': element.status === 'Offline'}"></div>
              </td>
            </ng-container>
            <!-- LastUpdatedTime (Mapped to lastDataTime) -->
            <ng-container matColumnDef="LastUpdatedTime">
              <th mat-header-cell *matHeaderCellDef style="text-align: center;font-weight: bold;background-color: wheat;">
                Last Updated Time&nbsp;&nbsp;
              </th>
              <td mat-cell *matCellDef="let element">
                {{element.dateTime }}
              </td>
            </ng-container>
            <!-- Status -->
            <ng-container matColumnDef="Status">
              <th mat-header-cell *matHeaderCellDef style="text-align: center; font-weight: bold; background-color: wheat;">
                Status&nbsp;&nbsp;
              </th>
              <td mat-cell *matCellDef="let element" (mouseenter)="alertdata(element.energyMeterId)">
                <img
                  [matTooltip]="alertsData"
                  matTooltipPosition="above"
                  matTooltipClass="auto-adjust-tooltip"
                  [src]="element.status === 'Online' ? 'assets/images/meters.png' : 'assets/images/meter.png'"
                  style="height: 24px; width: 24px;"
                />
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="[6, 12, 24]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- For Alert Section-->
<div *ngIf="!showstatus">
  <div class="modal-header" style="padding: 0px;">
      <div class="modal-title" id="exampleModalLabel">
        <mat-form-field style="margin-right: auto;" fxFlex="40%">
          <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Search">
        </mat-form-field>
      </div>
      <button
        type="button" mat-button
        (click)="close()" style="background-color: transparent;
        background-repeat: no-repeat;
        border: none;
        color: red;
        cursor: pointer;
        overflow: hidden;
        outline: none;"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="d-flex justify-content-center" style="margin-top: 1%;">
      <div class="col-md-10">
        <div class="col-md-12">
          <div style="overflow-x: auto; justify-content: center;">
            <table mat-table [dataSource]="dataSourcetwo" matSort class="example-container mat-elevation-z8" style="width: auto; text-align: center;">
              <!-- Energy Meter ID Column -->
              <ng-container matColumnDef="energyMeterId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center;font-weight: bold;background-color: wheat;cursor: pointer;">Energy Meter ID</th>
                <td style="cursor: pointer;" mat-cell *matCellDef="let element"> {{element.energyMeterId}} </td>
              </ng-container>
              <!-- Date Column -->
              <ng-container matColumnDef="DATE">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center;font-weight: bold;background-color: wheat;">Date</th>
                <td mat-cell *matCellDef="let element"> {{element.DATE | date: 'yyyy-MM-dd HH:mm:ss':'UTC'}} </td>
              </ng-container>
              <!-- Parameter Name Column -->
              <ng-container matColumnDef="parametername">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center;font-weight: bold;background-color: wheat;">Parameter Name</th>
                <td mat-cell *matCellDef="let element"> {{element.parametername}} </td>
              </ng-container>
              <!-- Actual Value Column -->
              <ng-container matColumnDef="actualvalue">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center;font-weight: bold;background-color: wheat;">Actual Value</th>
                <td mat-cell *matCellDef="let element"> {{element.actualvalue}} </td>
              </ng-container>
              <!-- Threshold Value Column -->
              <ng-container matColumnDef="thresholdvalue">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center;font-weight: bold;background-color: wheat;">Threshold Value</th>
                <td mat-cell *matCellDef="let element"> {{element.thresholdvalue}} </td>
              </ng-container>
              <!-- Table Header & Rows -->
              <tr mat-header-row *matHeaderRowDef="displayedColumnstwo"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnstwo;"></tr>
            </table>
            <mat-paginator #paginatorTwo [pageSizeOptions]="[6, 12, 24]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
</div>